import { logAndNotifyError, logDebugSilently } from "./logger";
import { BFLType, ModuleStatuses, ModuleTypeFamily, ModuleTypeId } from "../types/DBTables";
import { useGlobalData } from "../components/GlobalDataProvider";
import { DTOBuilding, DTOModule, DTORound } from "../types/building";
import { Driftoptimeringar, DriftoptimeringEntry, FunktionskontrollEntry, IGlobalData } from "../types/globalData";
import { IBIMHandler, getBIMHandler } from "./Beräkningsmoduler/bimHandler";
import { get, post } from "./server";
import Notify from "devextreme/ui/notify";
import { IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering, IKontrollResultSEKRow } from "../types/BFL/Funktionskontroll";
import { Breadcrumb } from "react-bootstrap";
import { NavigateFunction } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSnowflake, faSun } from "@fortawesome/free-solid-svg-icons";
import { BreadCrumbItem } from "../components/Global/StickyBreadCrumb";
import SunIcon from "../../Assets/sun.svg";
import { Colors } from "./Colors";
import { formatStringFn } from "./common";
//import { error } from "console";

export enum StepTypes {
  // "Init",
  // "EnterData",
  "EnterModulesData",
  "Finish",
}
export class RoundStep {
  constructor(readonly stepType: StepTypes, readonly data?: IRoundHeaderViewModel) {}
}

export enum RoundStatus {
  Draft = "Draft",
  Finished = "Finished",
  //Closed = "Closed",
}

export enum RoundModuleResult {
  FunktionsFel = "FunktionsFel",
  DriftsOptimering = "DriftsOptimering",
}

export interface IRound {
  id: number;
  date: Date;
  isSummer: boolean;
  status: RoundStatus;
  data: { modules: IModuleRound[] };
}

export interface IRoundHeaderViewModel {
  title: string;
  modules: IModuleRound[];
  allModulesReady: () => boolean;
}

export interface IRoundViewModel {
  transferNotesFromLastRound: () => void;
  id: number;
  buildingId: number;
  date: Date;
  isSummer: boolean;
  status: RoundStatus;
  steps: RoundStep[];
  bimHandler: IBIMHandler;
  getModules: (predicate: (m: IModuleRound) => boolean) => IModuleRound[];
  getLastFinishedRound: () => IRound | undefined;
}
export interface IBFContainer extends Partial<Record<BFLType, IBFResult>> {} //Can have (not required) properties corresponding to Enum BFLType of type IBFResult
// {
//   BFV_J3?: IBFResult;
//   BFV_J4?: IBFResult;
//   BFV_J5?: IBFResult;
//   BFV_J6?: IBFResult;
//   BFV_J8?: IBFResult;
//   BFV_J9?: IBFResult;
//   BFV_J10?: IBFResult;
//   BFV_J11?: IBFResult;
//   BFV_J12?: IBFResult;
//   BFV_J13?: IBFResult;
//   BFK_J1?: IBFResult;
//   BFL_J3_FTX_FT?: IBFResult;
//   BFL_J3_FX_F?: IBFResult;
//   BFL_J4_FTX?: IBFResult;
//   BFL_J5_FTX_FT?: IBFResult;
//   BFL_J3_S?: IBFResult;
// }

export interface IReportData {
  summary: {
    energySaved: number;
    potentialEnergyToSave: number;
    funktionsFelEnergySaved: number;
    funktionsFelPotentialEnergyToSave: number;
    driftOptimeringarEnergySaved: number;
    driftOptimeringarPotentialEnergyToSave: number;
    sekSaved: number;
    potentialSekToSave: number;
  };
  tables: { funktionsfel: any[]; driftoptimeringar: any[]; funktionsKontroller: any[]; funktionsKontrollerSEK: any[] };
}

export interface IRoundHandler {
  getActiveRound(): IRoundViewModel | undefined;
  startNewRound: (buildingId: number, isSummer: boolean) => Promise<IRound | undefined>;

  resumeRound: (dbround: DTORound) => Promise<IRound | undefined>;

  updateRoundConfig: (dbround: DTORound, building: DTOBuilding) => Promise<IRound | undefined>;

  getRoundViewModelFromId: (roundId: number) => IRoundViewModel;

  getRoundSummary: (roundVM: IRoundViewModel) => IReportData;

  ///Gets the active round
  getRoundData: () => { data: { modules: IModuleRound[] } } | undefined;

  getFinishedRound: () => DTORound | undefined;

  getBuilding: (buildingId: number) => DTOBuilding | undefined;

  getRound: (isSummer: boolean, building: DTOBuilding) => IRound;

  getRoundStep: (roundId: number, stepIndex: number) => Promise<RoundStep | undefined>;
  getBFNames: (modTypeId: ModuleTypeId) => BFLType[];
  getBimHandler: () => IBIMHandler;
  updateLastRoundLocally: (round: DTORound) => void;

  getLastFinishedRound: () => IRound | undefined;
  getBreadCrumbItems: (params: any) => BreadCrumbItem[];
  getDriftoptimering(
    bfName: BFLType,
    index: number,
    energy: number | undefined,
    energiSlag: string,
    options?: { variant?: string; OverrideBFName?: string; format?: string; formatFn?: (txt: string) => string }
  ): IKontrollResultRowDriftoptimering;
  getFunktionsKontroll(
    bfName: BFLType,
    index: number | string,
    energy: number | undefined,
    energiSlag: string,
    options?: { variant?: string; OverrideBFName?: string; format?: string; formatFn?: (txt: string) => string }
  ): IKontrollResultRow;
  getFunktionsKontrollSEK(bfName: BFLType, index: number | string, sek: number | undefined, options?: { variant?: string; formatFn?: (txt: string) => string }): IKontrollResultSEKRow;
}

export interface IModuleRound {
  name: string;
  moduleTypeId: ModuleTypeId;
  family: ModuleTypeFamily;
  ready: boolean;
  id: number;
  lastUpdated?: Date;
  data: any;
  bfs: IBFContainer;
}

export interface IRoundModuleResult {
  bfl: string;
  type: RoundModuleResult;
  rectified: boolean;
  family: ModuleTypeFamily;
  ready: boolean;
  values: any;
}

export const getRoundModuleSort = (isSummer: boolean) => {
  var moduleTypeOrder: any = {};

  moduleTypeOrder[ModuleTypeId.Byggnadsdata] = 1;
  moduleTypeOrder[ModuleTypeId.Lokaler] = 2;
  moduleTypeOrder[ModuleTypeId.VentilationF] = 3;
  moduleTypeOrder[ModuleTypeId.VentilationFT] = 3;
  moduleTypeOrder[ModuleTypeId.VentilationFX] = 3;
  moduleTypeOrder[ModuleTypeId.VentilationFTX] = 3;
  moduleTypeOrder[ModuleTypeId.VentilationS] = 3;
  moduleTypeOrder[ModuleTypeId.VarmePrimarFjarr] = 4;
  moduleTypeOrder[ModuleTypeId.VarmePrimarPump] = 4;
  moduleTypeOrder[ModuleTypeId.KylaVattenburet] = 5;
  moduleTypeOrder[ModuleTypeId.KylaMaskin] = 5;
  moduleTypeOrder[ModuleTypeId.VarmeSekundarVatten] = 6;
  moduleTypeOrder[ModuleTypeId.VarmeElAirotemper] = 7;
  moduleTypeOrder[ModuleTypeId.VarmeElGolvvarme] = 7;
  moduleTypeOrder[ModuleTypeId.VarmeElRadiatorer] = 7;
  moduleTypeOrder[ModuleTypeId.VarmeElStralningsvarmare] = 7;
  moduleTypeOrder[ModuleTypeId.VarmeElVarmepump] = 7;

  //Todo! Dessa är inte explicit nämnda i ppt, slide 10. Verifiera med Björn
  //   VentilationF;
  //   VentilationFX;
  //   VarmeElVarmepump;
  //   KylaVattenBuret;

  return (a: DTOModule, b: DTOModule) => {
    if (!moduleTypeOrder[a.moduleTypeId]) {
      console.error("ModuleTypeId " + a.moduleTypeId + " is not defined in moduleTypeOrder. Please check the order of the module types.");
    }
    if (!moduleTypeOrder[b.moduleTypeId]) {
      console.error("ModuleTypeId " + b.moduleTypeId + " is not defined in moduleTypeOrder. Please check the order of the module types.");
    }
    if (moduleTypeOrder[a.moduleTypeId] < moduleTypeOrder[b.moduleTypeId]) return -1;

    if (moduleTypeOrder[a.moduleTypeId] > moduleTypeOrder[b.moduleTypeId]) {
      return 1;
    }
    // Order secondly on name
    if (a.name < b.name) return -1;

    if (a.name > b.name) {
      return 1;
    }

    return 0;
  };
};

export const getModulesIncludedInRound = (modules: DTOModule[], isSummer: boolean) => {
  // let moduleTypes: ModuleTypeIds[] = [
  //   ModuleTypeIds.Byggnadsdata,
  //   ModuleTypeIds.Lokaler,
  //   ModuleTypeIds.VentilationFTX,
  //   ModuleTypeIds.VentilationFT,
  //   ModuleTypeIds.VentilationFX,
  //   ModuleTypeIds.VentilationF,
  //   ModuleTypeIds.VarmePrimarPump,
  //   ModuleTypeIds.VarmeSekundarVatten,
  //   ModuleTypeIds.VarmeElVarmepump,
  //   ModuleTypeIds.VarmeElStralningsvarmare,
  //   ModuleTypeIds.VarmeElGolvvarme,
  //   ModuleTypeIds.VarmeElAirotemper,
  //   ModuleTypeIds.VarmeElRadiatorer,
  //   ModuleTypeIds.KylaVattenburet,
  //   ModuleTypeIds.KylaMaskin,
  // ];

  let excludedModuleTypes: ModuleTypeId[] = [
    ModuleTypeId.KylaAnnatSystem,
    ModuleTypeId.KylaSaknas,
    ModuleTypeId.VarmePrimarSaknas,
    ModuleTypeId.VarmePrimarSaknas,
    ModuleTypeId.VarmePrimarAnnatSystem,
    ModuleTypeId.VarmeSekundarSaknas,
  ]; //ModuleTypeId.VentilationS

  if (isSummer) excludedModuleTypes.push(ModuleTypeId.VarmePrimarFjarr);

  return modules.filter((m) => !excludedModuleTypes.includes(m.moduleTypeId));
};

let activeRoundVM: IRoundViewModel | undefined = undefined;

export const useRound = (): IRoundHandler => {
  const global = useGlobalData();

  const dtoRoundToIRound = (dbround: DTORound): IRound => {
    const round = { ...JSON.parse(dbround.data), ...{ id: dbround.id, status: dbround.status, date: dbround.date, isSummer: dbround.isSummer } }; //todo : Add isSummer logic

    return round;
  };

  const getBimHandler = () => {
    if (!activeRoundVM) throw new Error("En rondering måste först ha startats!");
    return activeRoundVM.bimHandler;
  };

  const getRound = (isSummer: boolean, building: DTOBuilding): IRound => {
    const modulesUsed = getModulesIncludedInRound(building.modules, isSummer);
    const modulesUsedSorted = modulesUsed.sort(getRoundModuleSort(isSummer));

    const round = {
      id: 0,
      buildingId: building.id,
      date: new Date(),
      isSummer,
      status: RoundStatus.Draft,
      data: {
        modules: modulesUsedSorted.map((m) => {
          return {
            id: m.id,
            moduleTypeId: m.moduleTypeId,
            name: m.name,
            data: m.data ? JSON.parse(m.data) : {},
            family: global.moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.family as ModuleTypeFamily,
            ready: false,
            bfs: {},
          };
        }),
      },
    };

    return round;
  };
  const getFamilyTitel = (family: ModuleTypeFamily) => {
    switch (family) {
      case ModuleTypeFamily.Basdata:
        return "Basdata";
      case ModuleTypeFamily.VärmePrimar:
        return "Primärvärmesystem";
      case ModuleTypeFamily.VärmeSekundar:
        return "Sekundärvärmesystem";
      case ModuleTypeFamily.VärmeEl:
        return "Värmesystem el";
      case ModuleTypeFamily.Kyla:
        return "Kyla";
      case ModuleTypeFamily.Ventilation:
        return "Ventilation";
      default:
        return "?";
    }
  };

  const getRoundViewModel = async (round: IRound, buildingId: number): Promise<IRoundViewModel> => {
    let lastFinishedRound: IRound | undefined = undefined;
    const allFamilies = round.data.modules.reduce((acc, cur) => {
      let f = global.moduleTypes.find((mt) => mt.id === cur.moduleTypeId)?.family;
      if (f) {
        if (!acc.find((existing) => existing === f))
          //todo: Why any?
          acc.push(f);
      }
      return acc;
    }, [] as ModuleTypeFamily[]);

    const getModules = (predicate: (m: IModuleRound) => boolean): IModuleRound[] => {
      return round.data.modules.filter(predicate);
    };

    await (async () => {
      //Fetch and assign LastFinishedRound asynchroneously.
      const roundDate = new Date(round.date).toLocaleDateString("sv-SE");
      const result = await get("LastFinishedRound/" + buildingId.toString() + "/" + (round.isSummer ? "S" : "V") + "/" + roundDate);
      if (result.round) {
        lastFinishedRound = JSON.parse(result.round.data);
        if (lastFinishedRound) {
          if (result.roundOfSameType) {
            //merge the two rounds
            const roundOfSameType = JSON.parse(result.roundOfSameType.data);
            lastFinishedRound.data.modules.forEach((m: IModuleRound) => {
              const m2 = roundOfSameType.data.modules.find((m2: IModuleRound) => m2.id === m.id);
              if (m2) {
                m.bfs = { ...m2.bfs, ...m.bfs }; //Merge all the BFs. In the case that the BF exists in booth rounds, the last one will be the one that is kept.
              }
            });

            roundOfSameType.data.modules.forEach((m: IModuleRound) => {
              const m2 = (lastFinishedRound as IRound).data.modules.find((m2: IModuleRound) => m2.id === m.id);
              if (!m2) {
                (lastFinishedRound as IRound).data.modules.push(m);
              }
            });
          }
        }
      }
    })();

    const getLastFinishedRound = () => {
      return lastFinishedRound;
    };

    const transferNotesFromLastRound = () => {
      if (!lastFinishedRound) return;

      round.data.modules.forEach((m: IModuleRound) => {
        const m2 = (lastFinishedRound as IRound).data.modules.find((m2: IModuleRound) => m2.id === m.id);
        if (m2) {
          m.data.note = m2.data.note;
          if (m2.bfs && m.bfs) {
            getBFNames(m.moduleTypeId).forEach((bfName) => {
              // Object.keys(m2.bfs).forEach((bfName) => {
              const dbg = 5;
              if ((m.bfs as any)[bfName]) {
                const dbg = 5;
              } else {
                const dbg = 5;
                (m.bfs as any)[bfName] = { note: (m2.bfs as any)[bfName]?.note };
              }
            });
          }
        }
      });
    };

    const vm: IRoundViewModel = {
      id: round.id,
      buildingId: buildingId,
      date: round.date,
      isSummer: round.isSummer,
      status: round.status,
      steps: [],
      bimHandler: getBIMHandler(global.data as IGlobalData, round, buildingId),
      getModules: getModules,
      getLastFinishedRound: getLastFinishedRound,
      transferNotesFromLastRound,
    };

    function HeaderViewModel(title: string, modules: IModuleRound[]) {
      return {
        title: title,
        modules: modules,
        allModulesReady: () => {
          return !modules.find((m) => !m.ready);
        },
      };
    }

    for (var i = 0; i < allFamilies.length; i++) {
      const family = allFamilies[i];
      const title = getFamilyTitel(family);
      const modulesUnderHeader = round.data.modules.filter((m) => global.moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.family === family);
      vm.steps.push(new RoundStep(StepTypes.EnterModulesData, HeaderViewModel(title, modulesUnderHeader)));
    }

    vm.steps.push(new RoundStep(StepTypes.Finish));

    return vm;
  };

  //Is called synchronously and can only return if it's the currently active round. If ever needed async, make a separate function.
  const getRoundViewModelFromId = (roundId: number) => {
    if (activeRoundVM && activeRoundVM.id === roundId) return activeRoundVM;
    // {
    //   const res = await get("GetRound/" + roundId);
    //   if (res.round) {
    //     const iRound = dtoRoundToIRound(res.round);
    //     return getRoundViewModel(iRound, res.round.buildingId);
    //   } else
    else throw new Error("No round with id " + roundId + " could be fetched / created");
    // }
  };

  const getRoundSummary = (roundVM: IRoundViewModel) => {
    const ret = {
      summary: {
        energySaved: 0,
        potentialEnergyToSave: 0,
        funktionsFelEnergySaved: 0,
        funktionsFelPotentialEnergyToSave: 0,
        driftOptimeringarEnergySaved: 0,
        driftOptimeringarPotentialEnergyToSave: 0,
        sekSaved: 0,
        potentialSekToSave: 0,
      },

      tables: { funktionsfel: [] as any[], driftoptimeringar: [] as any[], funktionsKontroller: [] as any[], funktionsKontrollerSEK: [] as any[] },
    };
    const steps = roundVM.steps.filter((s) => s.stepType === StepTypes.EnterModulesData);
    for (var si = 0; si < steps.length; si++) {
      const step = steps[si];
      var modules = step.data?.modules;
      if (modules) {
        for (var mi = 0; mi < modules.length; mi++) {
          const module = modules[mi];

          const bfsNames = getBFNames(module.moduleTypeId);
          const bfs = (bfsNames.map((bl) => (module.bfs as any)[bl]) as IBFResult[]).filter((bf) => bf);
          bfs.map((bfr) => {
            if (bfr.driftOptimeringar && bfr.driftOptimeringar.length) {
              bfr.driftOptimeringar.map((optimering) => {
                if (optimering.kWhs && typeof optimering.kWhs === "number") {
                  const value = (optimering as IKontrollResultRowDriftoptimering).inverteraTecken ? -optimering.kWhs : optimering.kWhs;
                  if (optimering.Åtgärdad) {
                    ret.summary.energySaved += value;
                    ret.summary.driftOptimeringarEnergySaved += value;
                  } else {
                    ret.summary.potentialEnergyToSave += value;
                    ret.summary.driftOptimeringarPotentialEnergyToSave += value;
                  }

                  ret.tables.driftoptimeringar.push({
                    system: module.name,
                    family: module.family,
                    kWhs: optimering.kWhs,
                    energiSlag: optimering.energiSlag,
                    message: optimering.message,
                    Åtgärdad: optimering.Åtgärdad,
                    inverteraTecken: (optimering as IKontrollResultRowDriftoptimering).inverteraTecken,
                  });
                }
                return 0;
              });
            }
            if (bfr.funktionsKontroller && bfr.funktionsKontroller.length) {
              bfr.funktionsKontroller.map((fk) => {
                const visaÅtgärdad = fk.VisaÅtgärdad ? true : false;
                if (fk.kWhs && typeof fk.kWhs === "number") {
                  if (fk.Åtgärdad) {
                    ret.summary.energySaved += fk.kWhs;
                    ret.summary.funktionsFelEnergySaved += fk.kWhs;
                  } else {
                    ret.summary.potentialEnergyToSave += fk.kWhs;
                    ret.summary.funktionsFelPotentialEnergyToSave += fk.kWhs;
                  }

                  ret.tables.funktionsfel.push({
                    system: module.name,
                    family: module.family,
                    kWhs: fk.kWhs,
                    energiSlag: fk.energiSlag,
                    message: fk.message,
                    Åtgärdad: fk.Åtgärdad,
                    KanÅtgärdas: visaÅtgärdad,
                  });
                } else {
                  ret.tables.funktionsKontroller.push({
                    system: module.name,
                    family: module.family,
                    message: fk.message,
                    Åtgärdad: fk.Åtgärdad,
                    KanÅtgärdas: visaÅtgärdad,
                  });
                }
                return 0;
              });
            }

            if (bfr.funktionsKontrollerSEK && bfr.funktionsKontrollerSEK.length) {
              bfr.funktionsKontrollerSEK.map((fk) => {
                const visaÅtgärdad = fk.VisaÅtgärdad ? true : false;
                if (fk.sek && typeof fk.sek === "number") {
                  if (fk.Åtgärdad) {
                    ret.summary.sekSaved += fk.sek;
                  } else {
                    ret.summary.potentialSekToSave += fk.sek;
                  }

                  ret.tables.funktionsKontrollerSEK.push({
                    system: module.name,
                    family: module.family,
                    sek: fk.sek,
                    message: fk.message,
                    Åtgärdad: fk.Åtgärdad,
                    KanÅtgärdas: visaÅtgärdad,
                  });
                } else {
                  ret.tables.funktionsKontrollerSEK.push({
                    system: module.name,
                    family: module.family,
                    message: fk.message,
                    KanÅtgärdas: visaÅtgärdad,
                  });
                }
                return 0;
              });
            }

            return 0;
          });
        }
      }
    }

    return ret;
  };

  const getRoundStep = async (roundId: number, stepIndex: number) => {
    logDebugSilently("getRoundStep:" + roundId + "," + stepIndex + " @ " + new Date());
    if (!activeRoundVM) {
      const res = await get("GetRound/" + roundId);
      if (res.round && global.moduleTypes && global.moduleTypes.length) {
        const iRound = dtoRoundToIRound(res.round);
        activeRoundVM = await getRoundViewModel(iRound, res.round.buildingId);
      }
    }

    return activeRoundVM?.steps[stepIndex];
  };

  const updateLastRoundLocally = (round: DTORound) => {
    const activeBuilding = global.buildings?.find((b) => b.id === round.buildingId);

    if (activeBuilding) {
      // if (activeBuilding.lastRound?.id === 0) {
      // }
      //activeBuilding.lastRound = round;
      if (activeRoundVM) activeRoundVM.id = round.id;
    }
  };

  const getRoundData = () => {
    if (!activeRoundVM) return undefined;

    const ret = {
      //id: activeRoundVM.id,
      //date: activeRoundVM.date,
      //isSummer: activeRoundVM.isSummer,
      //status: activeRoundVM.status,
      data: {
        modules: [] as any[],
      },
    };

    const moduleSteps = activeRoundVM.steps.filter((s) => s.stepType === StepTypes.EnterModulesData);
    moduleSteps.forEach((stp) => {
      if (stp.data) {
        stp.data.modules.forEach((m) => {
          ret.data.modules.push(m);
        });
      }
    });

    return ret;
  };

  const getActiveRound: () => IRoundViewModel | undefined = () => activeRoundVM;

  const getFinishedRound = () => {
    if (!activeRoundVM) return undefined;

    const roundData = getRoundData();
    const ret: DTORound = {
      id: activeRoundVM.id,
      buildingId: activeRoundVM.buildingId,
      date: activeRoundVM.date,
      status: activeRoundVM.status,
      data: JSON.stringify(roundData),
      isSummer: activeRoundVM.isSummer,
    };

    return ret;
  };

  const getBFNames = (modTypeId: ModuleTypeId): BFLType[] => {
    if (!activeRoundVM) return [];
    const isSummer = activeRoundVM.isSummer;
    if (isSummer)
      switch (modTypeId) {
        case ModuleTypeId.VarmeSekundarVatten:
          return [BFLType.BFV_J5, BFLType.BFV_J8];
        case ModuleTypeId.VarmePrimarFjarr:
          return [];
        case ModuleTypeId.VarmePrimarPump:
          return [BFLType.BFV_J13];
        case ModuleTypeId.VarmeElRadiatorer:
        case ModuleTypeId.VarmeElAirotemper:
        case ModuleTypeId.VarmeElGolvvarme:
        case ModuleTypeId.VarmeElStralningsvarmare:
        case ModuleTypeId.VarmeElVarmepump:
          return [BFLType.BFV_J12];

        case ModuleTypeId.KylaMaskin:
          return [BFLType.BFK_J1];
        case ModuleTypeId.VentilationFTX:
        case ModuleTypeId.VentilationFT:
          return [BFLType.BFL_J3_FTX_FT, BFLType.BFL_J5_FTX_FT];
        case ModuleTypeId.VentilationFX:
          return [BFLType.BFL_J3_FX_F, BFLType.BFV_J13];
        case ModuleTypeId.VentilationF:
          return [BFLType.BFL_J3_FX_F];
        case ModuleTypeId.VentilationS:
          return [BFLType.BFL_J3_S];
        default:
          return [];
      }
    //Vinterrondering
    else
      switch (modTypeId) {
        case ModuleTypeId.VarmeSekundarVatten:
          return [BFLType.BFV_J3, BFLType.BFV_J9];
        case ModuleTypeId.VarmePrimarFjarr:
          return [BFLType.BFV_J10];
        case ModuleTypeId.VarmePrimarPump:
          return [BFLType.BFV_J13];
        case ModuleTypeId.VarmeElRadiatorer:
        case ModuleTypeId.VarmeElAirotemper:
        case ModuleTypeId.VarmeElGolvvarme:
        case ModuleTypeId.VarmeElStralningsvarmare:
        case ModuleTypeId.VarmeElVarmepump:
          return [BFLType.BFV_J11];
        case ModuleTypeId.KylaMaskin:
          return [BFLType.BFK_J1];
        case ModuleTypeId.VentilationFTX:
          return [BFLType.BFL_J3_FTX_FT, BFLType.BFL_J4_FTX, BFLType.BFL_J5_FTX_FT];
        case ModuleTypeId.VentilationFT:
          return [BFLType.BFL_J3_FTX_FT, BFLType.BFL_J5_FTX_FT];
        case ModuleTypeId.VentilationFX:
          return [BFLType.BFL_J3_FX_F, BFLType.BFV_J13];
        case ModuleTypeId.VentilationF:
          return [BFLType.BFL_J3_FX_F];
        case ModuleTypeId.VentilationS:
          return [BFLType.BFL_J3_S];
        default:
          return [];
      }
  };

  const getBuilding = (buildingId: number) => {
    const buildings = global.buildings;
    if (!buildings) return undefined;
    return buildings.find((b) => b.id === buildingId);
  };

  const getBreadCrumbItems = (params: any) => {
    //return <></>;
    try {
      let roundId: string | number | undefined = params.roundId;
      let stepIndex: string | number | undefined = params.stepIndex;
      let moduleIndex: string | number | undefined = params.moduleIndex;
      let BLFIndex: string | number | undefined = params.BLFIndex;

      const items: BreadCrumbItem[] = [];
      if (!roundId) return items;
      const vm = getRoundViewModelFromId(Number(roundId));
      const building = getBuilding(vm?.buildingId);
      if (!building) return items;

      const buildingInfo = building?.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
      const buildingData = buildingInfo ? JSON.parse(buildingInfo) : undefined;
      const område = buildingData?.område as string;

      items.push({
        icon: vm.isSummer ? faSun : faSnowflake,
        text: område + " - " + building.name,
        navTo: "/Buildings/" + building.id,
        title: vm.isSummer ? "Sommar-rondering" : "Vinter-rondering",
        color: vm.isSummer ? Colors.YellowMedium : Colors.BlueLight,
      });

      if (stepIndex) {
        stepIndex = Number(stepIndex);
        const step = vm.steps[stepIndex];
        const title = step.stepType === 1 ? "Rapport" : step.data?.title || "";

        items.push({ text: title, navTo: "/round/" + roundId + "/" + stepIndex });
        if (moduleIndex) {
          const modIndex = Number(moduleIndex);
          const activeModule = step.data?.modules[modIndex];
          items.push({ text: activeModule?.name || "", navTo: "/round/" + roundId + "/" + stepIndex + "/" + modIndex });
          if (BLFIndex && activeModule) {
            const bfs = getBFNames(activeModule.moduleTypeId);
            const bflIndex = Number(BLFIndex);
            let bfName = bfs[bflIndex];
            items.push({ text: bfName, navTo: "/round/" + roundId + "/" + stepIndex + "/" + moduleIndex + "/" + BLFIndex });
          }
        }
      }

      items[items.length - 1].active = true;
      return items;
    } catch (error) {
      logAndNotifyError(error);
      return [];
    }
  };

  const bfKey: Record<BFLType, string> = {
    BFV_J3: "BFVJ3",
    BFV_J4: "BFVJ4",
    BFV_J5: "BFVJ5",
    BFV_J6: "BFVJ6",
    BFV_J8: "BFVJ8",
    BFV_J9: "BFVJ9",
    BFV_J10: "BFVJ10",
    BFV_J11: "BFVJ11",
    BFV_J12: "BFVJ12",
    BFV_J13: "BFVJ13",
    BFK_J1: "BFKJ1",
    BFL_J3_FTX_FT: "BFLJ3FTX",
    BFL_J3_FX_F: "BFLJ3FX",
    BFL_J4_FTX: "BFLJ4FTX",
    BFL_J5_FTX_FT: "BFLJ5FTX",
    BFL_J3_S: "BFLJ3S",
    Unknown: "Unknown",
    NotYetImplemented: "NotYetImplemented",
  };

  const getDriftoptimering = (
    bfName: BFLType,
    index: number,
    energy: number | undefined,
    energiSlag: string,
    options?: { OverrideBFName?: string; variant?: string; format?: string; formatFn?: (txt: string) => string }
  ): IKontrollResultRowDriftoptimering => {
    const doKey = bfKey[bfName] + "_OptText" + index + (options?.variant || ""); //"BFLJ3FTX_OptText1"  //BFLJ5FTX_OptText3a1 (variant = a1)

    const doEntry = (global?.data?.Driftoptimeringar?.mapDriftoptimeringar as any)[doKey] as DriftoptimeringEntry | undefined;
    if (!doEntry) return { index, kWhs: 0, energiSlag: "?", message: "Ingen text hittades för " + doKey, inverteraTecken: false, VisaÅtgärdad: false, VisaMerInfo: false };
    else {
      const ret: IKontrollResultRowDriftoptimering = {
        index,
        kWhs: energy,
        energiSlag,
        message: doEntry.Text,
        inverteraTecken: doEntry.InverteraTecken,
        category: doEntry.Rubrik,
        VisaÅtgärdad: doEntry.VisaÅtgärdad,
        VisaMerInfo: doEntry.VisaMerInfo,
        variant: options?.variant,
        Åtgärdad: true, //En driftoptimering är alltid "Åtgärdad" per definition (Ny def...)
      };

      if (options) {
        if (options.OverrideBFName) ret.OverrideBFName = options.OverrideBFName;
        if (options.format) {
          switch (options.format) {
            case "0dec":
              ret.kWhs = "";
          }
        }
        if (options.formatFn) {
          ret.message = formatStringFn(ret.message, options.formatFn);
        }
      }

      return ret;
    }
  };

  const getFunktionsKontroll = (
    bfName: BFLType,
    index: number,
    energy: number | undefined,
    energiSlag: string,
    options?: { OverrideBFName?: string; variant?: string; format?: string; formatFn?: (txt: string) => string }
  ): IKontrollResultRow => {
    const doKey = bfKey[bfName] + "_FKText" + index + (options?.variant || ""); //BFVJ13_FKText1
    const dbg = 5;
    const doEntry = (global?.data?.Funktionskontroller?.mapFunktionskontroller as any)[doKey] as undefined | FunktionskontrollEntry;
    if (!doEntry) return { index, kWhs: 0, energiSlag: "?", message: "Ingen text hittades för " + doKey, VisaÅtgärdad: false, VisaMerInfo: false };
    else {
      const ret: IKontrollResultRow = {
        index,
        kWhs: energy,
        energiSlag,
        message: doEntry.Text,
        variant: options?.variant,
        category: doEntry.Rubrik,
        VisaMerInfo: doEntry.VisaMerInfo,
        VisaÅtgärdad: doEntry.VisaÅtgärdad,
      };

      if (options) {
        if (options.OverrideBFName) ret.OverrideBFName = options.OverrideBFName;
        if (options.format) {
          switch (options.format) {
            case "0dec":
              ret.kWhs = "";
          }
        }
        if (options.formatFn) {
          ret.message = formatStringFn(ret.message, options.formatFn);
        }
      }

      return ret;
    }
  };

  const getFunktionsKontrollSEK = (bfName: BFLType, index: number, sek: number | undefined, options?: { variant?: string; formatFn?: (txt: string) => string }): IKontrollResultSEKRow => {
    const doKey = bfKey[bfName] + "_FKText" + index + (options?.variant || "");
    const dbg = 5;
    const doEntry = (global?.data?.Funktionskontroller?.mapFunktionskontroller as any)[doKey] as undefined | FunktionskontrollEntry;
    if (!doEntry) return { index, sek: 0, message: "Ingen text hittades för " + doKey, VisaÅtgärdad: false, VisaMerInfo: false };
    else {
      const ret: IKontrollResultSEKRow = {
        index,
        sek: sek,
        message: doEntry.Text,
        VisaMerInfo: doEntry.VisaMerInfo,
        VisaÅtgärdad: doEntry.VisaÅtgärdad,
      };

      if (options) {
        if (options.formatFn) {
          ret.message = formatStringFn(ret.message, options.formatFn);
        }
      }

      return ret;
    }
  };

  //Public stuff
  var mod = {
    startNewRound: async (buildingId: number, isSummer: boolean): Promise<IRound | undefined> => {
      const buildings = global.buildings;
      if (buildings) {
        const b = buildings.find((bb) => bb.id === buildingId);
        if (b) {
          const round = getRound(isSummer, b);
          activeRoundVM = await getRoundViewModel(round, b.id);
          activeRoundVM.transferNotesFromLastRound();
          const theRound = getFinishedRound() as DTORound;
          const res = await post("SaveRound", theRound);
          if (res?.succeeded) {
            updateLastRoundLocally(res.round);
            Notify("En ny rondering har skapats", "success");
            return res.round;
          } else {
            logAndNotifyError("Rondering har inte kunnat initieras!");
          }
        } else {
          logAndNotifyError("Rondering har inte kunnat initieras (Ingen byggnad)!");
        }
      } else logAndNotifyError("Rondering har inte initierats!");
    },
    resumeRound: async (dbround: DTORound): Promise<IRound | undefined> => {
      const round = dtoRoundToIRound(dbround);
      activeRoundVM = await getRoundViewModel(round, dbround.buildingId);

      Notify("Rondering har återupptagits", "success");
      return round;
    },
    updateRoundConfig: async (dbround: DTORound, building: DTOBuilding): Promise<IRound | undefined> => {
      const round = dtoRoundToIRound(dbround);
      const updatedModules = [] as IModuleRound[];
      let error = "";
      const ignoredModuleTypes = [ModuleTypeId.KylaAnnatSystem, ModuleTypeId.KylaSaknas, ModuleTypeId.VarmePrimarSaknas, ModuleTypeId.VarmeSekundarSaknas, ModuleTypeId.VarmePrimarAnnatSystem];
      const anyNotConfigured = building.modules.find((m) => m.status !== ModuleStatuses.Configured && !ignoredModuleTypes.includes(m.moduleTypeId));
      if (anyNotConfigured) {
        error = "Alla moduler måste först vara konfigurerade!";
        Notify(error, "error");
        return;
      }

      round.data.modules.forEach((m) => {
        const cnfMod = building.modules.find((cm) => cm.name === m.name);
        if (cnfMod) {
          if (ignoredModuleTypes.includes(m.moduleTypeId)) return;

          const modCfg = JSON.parse(cnfMod.data);
          m.data = { ...m.data, ...modCfg };
          updatedModules.push(m);
        } //else it has been removed in config - don't transfer it
      });

      //Existing (in the round and in the config) modules have been updated.
      //If any modules have been added in the config, add those as well.
      building.modules.forEach((m) => {
        if (ignoredModuleTypes.includes(m.moduleTypeId)) return;

        let roundMod = round.data.modules.find((rm) => rm.name === m.name);
        if (!roundMod) {
          //Module was not found in round - Add it

          roundMod = {
            id: m.id,
            moduleTypeId: m.moduleTypeId,
            name: m.name,
            data: m.data ? JSON.parse(m.data) : {},
            family: global.moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.family as ModuleTypeFamily,
            ready: false,
            bfs: {},
          };
          updatedModules.push(roundMod);
        }
      });

      //Reset all modules to not ready. This forces the user to pass through all validation stepes again.
      updatedModules.forEach((m) => {
        m.ready = false;
      });

      if (error) {
        Notify(error, "error");
        return;
      }
      round.data.modules = updatedModules;

      activeRoundVM = await getRoundViewModel(round, dbround.buildingId);
      const theRound = getFinishedRound() as DTORound;
      const res = await post("SaveRound", theRound);
      if (res?.succeeded) {
        updateLastRoundLocally(res.round);
        Notify("Rondering har uppdaterats", "success");
        return round;
      } else {
        logAndNotifyError("Rondering har inte kunnat uppdateras!");
      }
    },
    getRoundViewModelFromId: getRoundViewModelFromId,
    getRoundSummary: getRoundSummary,
    getRoundData: getRoundData,
    getActiveRound: getActiveRound,

    getFinishedRound: getFinishedRound,

    getBuilding,

    //mod is a module returned by useRound
    getRound: getRound,

    getRoundStep: getRoundStep,
    getBFNames: getBFNames,
    getBimHandler: getBimHandler,
    updateLastRoundLocally: updateLastRoundLocally,
    getLastFinishedRound: () => {
      if (activeRoundVM) return activeRoundVM.getLastFinishedRound();
      else return undefined;
    },
    getBreadCrumbItems,
    getDriftoptimering,
    getFunktionsKontroll,
    getFunktionsKontrollSEK,
  };

  return mod;
};

const dflt = { useRound, getRoundModuleSort };

export default dflt;
